import { Editor } from 'roosterjs-editor-core';
import { PluginEvent, PluginEventType, PluginDomEvent } from 'roosterjs-editor-types';

export default function inlineImageResizePluginTrigger(evt: PluginEvent, editor: Editor) {
    if (evt.eventType == PluginEventType.MouseUp) {
        const domElement = <Element>(<PluginDomEvent>evt).rawEvent.target;
        if (domElement != null && domElement.nodeName == 'IMG') {
            return true;
        }
    }

    return false;
}
